export enum ObjectNames {
    CHANNEL_TYPE_NAME = "Channel",
    TEMPLATE_TYPE_NAME = "Template",
    PIPELINE_TYPE_NAME = "Pipeline",
    COLUMN_SETTING_TYPE = "ColumnSettings",

    CONTACTS_EMAIL_TYPES = "Contacts Email Types",
    CONTACTS_PHONE_TYPES = "Contacts Phone Types",
    CONTACTS_SOCIAL_TYPES = "Contacts Social Types",
    CONTACT_TEMPLATE = "Contact Template",
    CONTACT_COLUMN_SETTINGS = "Contact Column Settings",

    DASHBOARD = "Dashboard",
    STREAM = "Stream",

    COMPANY_DETAILS = "Company And Location",
    PRIVACY = "Privacy",
    ROLE = "Roles",
    USER = "Users",
    MOBILE_APP = "MobileApp",
    WEB = "Web",
    NOTIFICATION = "Notification",
    ACCOUNT = "Account",
    CONTACT = "Contact",
    TERRITORY = "Territory",
    FINANCE = "Finance",
    QUESTIONNAIRE = "Questionnaire",
    GOAL = "Goal",
    LEAD = "Lead",
    LEADS = "Leads",
    LEAD_SCORE = "LeadScoring",
    OPPORTUNITY = "Opportunity",
    OPPORTUNITY_SCORE = "OpportunityScoring",
    LEAD_LIFE_CYCLE_STAGE = "Lead Life Cycle Stage",
    ROUTE = "Route",
    SavedSearch = "SavedSearch",
    SavedSearchAnalytics = "SavedSearchAnalytics",
    PREDICT_FORECAST="PredictForecast",
    IMPORT_EXPORT = "ImportExport",
    WORKFLOW = 'WorkFlow',
    CAMPAIGN = 'Messaging',

    FINANCE_SETUP = "Finance SetUp",

    QUOTATION = "Quotation",
    CLOSING_YEAR = "Closing Years",
    SALES_ORDER = "SalesOrder",
    INVOICE = "Invoice",
    ESTIMATE = "Estimate",
    RECEIVE_PAYMENT = "Receive Payment",
    Customer_RMA = "Customer RMA",
    Credit_Memo = "Credit Memo",
    PRODUCT = "Product",
    LOCATION = "Location",
    INVENTORY_SETUP = "Inventory SetUp",
    QUANTITY = "Quantity",
    ORDER = "SalesOrder",
    CUSTOM = "Custom",
    CUSTOMERS = "Customers",

    PURCHASE = "Purchases",
    Item_Receipt = "Item Receipt",
    Bill = "Bill",
    Bill_Payment = "BillPayment",
    Vendor = "Vendor",
    Vendor_Returns = "VendorReturns",
    Vendor_Credit = "VendorCredit",
    WAREHOUSE = "Warehouse",
    LEAVE_MANAGEMENT = "Leave Management",
    TASK = "Task",
    CONFIGURATION = "Configuration",

    EVENT = "Event",
    LOG = "Log",
    NOTE = "Note",
    EMAIL = "Email",

    CASE = "Case",
    CASES = "Cases",
    CASES_LIFE_CYCLE_STAGE = "Cases Life Cycle Stage",
    CASE_COLUMN_SETTINGS = "Case Column Settings",
    CRM_CUSTOM = "CRM Custom",

    LEAD_EMAIL_TYPES = "Lead Email Types",
    LEAD_PHONE_TYPES = "Lead Phone Types",
    LEAD_SOCIAL_TYPES = "Lead Social Types",
    LEAD_TEMPLATE = "Lead Template",
    LEAD_COLUMN_SETTINGS = "Lead Column Settings",

    ACCOUNT_EMAIL_TYPES = "Account Email Types",
    ACCOUNT_PHONE_TYPES = "Account Phone Types",
    ACCOUNT_SOCIAL_TYPES = "Account Social Types",
    ACCOUNT_GROUPS = "Account Groups",
    ACCOUNT_CHANNEL = "Account Channel",
    ACCOUNT_TEMPLATE = "Account Template",
    ACCOUNT_COLUMN_SETTINGS = "Account Column Settings",

    FIELD_CASES_CONFIGURATION = "Field Data Cases Configuration",
    CHANNEL_CASES_CONFIGURATION = "Channel Cases Configurtion",
    CHANNEL_STAGE_CONFIGURATION = "Channel Stage Configurtion",
    TEMPLATE_CASES_CONFIGURATION = "Template Cases Configuration",
    USER_TEMPLATE = "User Template",
    ROLE_TEMPLATE = "Role Template",

    OPPORTUNITY_PIPELINE = "Opportunity Pipeline",
    OPPORTUNITY_STAGES = "Opportunity Stages",
    OPPORTUNITY_TEMPLATE = "Opportunity Template",
    OPPORTUNITY_LIFE_CYCLE_STAGE = "Opportunity Life Cycle Stage",
    OPPORTUNITY_COLUMN_SETTINGS = "Opportunity Column Settings",

    ROUTE_COLUMN_SETTINGS = "Route Column Settings",

    TERRITORY_COLUMN_SETTINGS = "Territory Column Settings",

    QUESTIONNAIRE_TEMPLATE = "Questionnaire Template",

    DASHBOARD_USER_SETTINGS = "Dashboard",

    CHANNEL_BUNDLE = "Bundle Item",
    CHANNEL_KIT = "Kit/Package Items",

    Inventory_Item = 'Inventory Item',
    Bundle_Item = 'Bundle Item',
    Non_Inventory_Item = 'Non Inventory Item',
    Service_Item = 'Service',
    Kit_Items = 'Kit/Package Items'

}
